import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Button, Center, Heading, Spinner, VStack } from '@chakra-ui/react';
import { SubscriptionListItem } from '@src/components/sco/Account/UserSubscriptionList/SubscriptionListItem';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { gql } from '@src/lib/gql';
import React from 'react';
type UserSubscriptionListProps = {};
export const UserSubscriptionList = props => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      {
        viewer {
          id
          currentUser {
            id
            subscriptions {
              id
              appliedCouponCode
              activatedAt
              canBeCanceled
              canceledAt
              cancelPreventedAt
              cardLabel
              chargebeeCustomerId
              chargebeeSubscriptionId
              delayedCancelAt
              isActive
              isLifetime
              nextAssessmentAt
              nextAssessmentAmountInCents
              scoProduct {
                id
                effectivePricingInCents {
                  signup
                  recurring
                }
              }
              product {
                id
                durationInYears
                effectivePrices {
                  id
                  signup
                  recurring
                }
                productId
                name
                specialTermsNote
                tags
                term {
                  abbreviation
                  description
                  isRecurring
                  label
                  name
                  termId
                }
                termId
              }
              productId
              subscriptionId
              state
              updatePaymentMethodLink
            }
          }
        }
      }
    `;
    t1 = {
      ssr: false,
      fetchPolicy: "network-only"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const query = useQuery(t0, t1);
  if (query.loading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center padding="1em"><Spinner /></Center>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== query.data) {
    t2 = <VStack align="stretch" gap="1em" width="full">{query.data?.viewer?.currentUser?.subscriptions?.length > 0 ? <><Heading>Billing Information</Heading>{query.data.viewer.currentUser.subscriptions.map(_temp)}</> : <Center><VStack bgColor="colorPalette.container" borderRadius="xl" boxShadow="lg" maxWidth="480px" padding="4em 2em 2em 2em" width="full"><Heading>No Subscription Yet</Heading><Button asChild={true} marginTop="1em" size="lg" variant="cta" width="full"><NextLink href="/accelerator/plans">Upgrade Now</NextLink></Button></VStack></Center>}</VStack>;
    $[3] = query.data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(subscription) {
  return <SubscriptionListItem key={subscription.id} subscription={subscription} />;
}